import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {BaseComponent} from '../base.component';
import {CustomModalService} from '../../services/custom-modal.service';
import {Subject} from 'rxjs';
import {switchMap} from 'rxjs/operators';
import {UploadPhotoModalComponent} from '../../modals/upload-photo-modal/upload-photo-modal.component';
import {FileUploadModel, IFileInfo} from '@ui-app/models/common.models';
import {FileUploadAction, EREQUEST_ACTION} from '@shared-models/common.enums';

@Component({
    selector: 'ui-upload-photo',
    templateUrl: './upload-photo.component.html',
    styleUrls: ['./upload-photo.component.less']
})
export class UploadPhotoComponent extends BaseComponent implements OnInit {
    @Input() uploadConfig: Record<string, string | number | any> = {};
    @Input() newFileName: string;
    @Output() onUploadPhoto = new EventEmitter<IFileInfo[]>();
    @Input() buttonType = 'secondary';
    @Input() buttonText = 'Upload photo';
    @Input() buttonIcon = false;
    @Input() isVisitorRequest = false;
    @Input() isAttachment = false;
    @Input() isExtension = false;
    @Input() employeeFunctionId: number | null = null;
    action: EREQUEST_ACTION;
    private uploadPhoto$ = new Subject<void>();

    constructor(
        private customModalService: CustomModalService,
    ) {
        super();
    }

    ngOnInit(): void {
        this.handleUploadPhoto();
    }

    private handleUploadPhoto(): void {
        this.subs = this.uploadPhoto$
            .pipe(
                switchMap(() => this.customModalService.initModal(UploadPhotoModalComponent,
                    {
                        uploadConfig: this.uploadConfig,
                        newFileName: this.newFileName,
                        isVisitorRequest: this.isVisitorRequest,
                        isAttachment: this.isAttachment,
                        isExtension: this.isExtension,
                        employeeFunctionId: this.employeeFunctionId,
                    }, 'modal-520')), // tslint:disable-line
            )
            .subscribe((files: FileUploadModel) => {
                switch (files.action) {
                    case FileUploadAction.Delete:
                        // Files are automatically removed by backend
                        break;
                    case FileUploadAction.Upload:
                        this.onUploadPhoto.emit(files.data);
                        break;
                    case FileUploadAction.Cancel:
                        break;
                }
            });
    }

    uploadPhoto(): void {
        this.uploadPhoto$.next();
    }
}
